module.exports = __webpack_public_path__ + "static/media/caffe.a90bb0cd.svg";